(function () {
  if (window.MaruishiVideoOnDemand) {
    window.MaruishiVideoOnDemand.initialize(document);
    return;
  }

  function setShowcaseState(video, isPlaying) {
    var card = video.closest('.hvs-card');
    if (!card) return;

    card.classList.toggle('is-playing', isPlaying);
    var toggle = card.querySelector('[data-hvs-toggle]');
    if (!toggle) return;

    var title = card.querySelector('.hvs-card__title');
    var label = title ? title.textContent.trim() : '動画';
    toggle.setAttribute('aria-label', label + (isPlaying ? 'を一時停止' : 'を再生'));
  }

  function hydrate(video) {
    if (video.dataset.vodInitialized === 'true') return;

    var source = video.querySelector('source[data-src]');
    if (!source || !source.dataset.src) return;

    source.setAttribute('src', source.dataset.src);
    source.removeAttribute('data-src');
    video.dataset.vodInitialized = 'true';

    if (video.hasAttribute('data-vod-native-controls')) {
      video.controls = true;
    }

    var container = video.closest('[data-vod-frame], .hvs-card');
    var playButton = container && container.querySelector('[data-vod-play]');
    if (playButton && !playButton.hasAttribute('data-vod-persistent')) {
      playButton.hidden = true;
    }

    video.load();
  }

  function play(video) {
    hydrate(video);
    if (video.dataset.vodInitialized !== 'true') return;

    video.muted = true;
    var promise = video.play();
    if (promise && promise.catch) {
      promise.catch(function () {
        setShowcaseState(video, false);
      });
    }
  }

  function bindVideo(video) {
    if (video.dataset.vodBound === 'true') return;
    video.dataset.vodBound = 'true';

    video.addEventListener('play', function () {
      setShowcaseState(video, true);
    });
    video.addEventListener('pause', function () {
      setShowcaseState(video, false);
    });
    video.addEventListener('ended', function () {
      setShowcaseState(video, false);
    });

    var container = video.closest('[data-vod-frame], .hvs-card');
    var playButton = container && container.querySelector('[data-vod-play]');
    if (!playButton) return;

    playButton.addEventListener('click', function () {
      if (video.dataset.vodInitialized === 'true' && !video.paused) {
        video.pause();
        return;
      }
      play(video);
    });
  }

  function bindShowcaseAutoplay(root) {
    if (root.dataset.hvsReady === 'true') return;
    root.dataset.hvsReady = 'true';

    var reducedMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || root.dataset.hvsAutoplay !== 'true' || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          play(entry.target);
        } else if (entry.target.dataset.vodInitialized === 'true') {
          entry.target.pause();
        }
      });
    }, { threshold: 0.42, rootMargin: '120px 0px' });

    root.querySelectorAll('[data-hvs-video]').forEach(function (video) {
      observer.observe(video);
    });
    root.vodIntersectionObserver = observer;
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-vod-video]').forEach(bindVideo);
    scope.querySelectorAll('[data-hvs-section]').forEach(bindShowcaseAutoplay);

    if (scope.matches && scope.matches('[data-vod-video]')) bindVideo(scope);
    if (scope.matches && scope.matches('[data-hvs-section]')) bindShowcaseAutoplay(scope);
  }

  window.MaruishiVideoOnDemand = { initialize: initialize };
  initialize(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-hvs-section]');
    if (root && root.vodIntersectionObserver) root.vodIntersectionObserver.disconnect();
  });
})();
